import {closePageOverlay, showPageOverlay} from './MainNavigationHandler';

export function landingpageSwitch() {
  const landingpageSwitchDesktop = document.querySelector('.js-landingpageSwitchHeader'); // desktop button
  const landingpageSwitchMobile = document.querySelector('.js-landingpageSwitch'); //mobile button
  const landingPageSection = document.querySelector('.js-landingPageSection'); // overlay menu

  if (landingpageSwitchMobile instanceof HTMLElement) {
    landingpageSwitchMobile.addEventListener('click', () => {
      if (landingpageSwitchMobile.classList.contains('landingPageSwitch--active')) {
        closeLandingpageMenu();
        landingpageSwitchMobile?.classList.remove('landingPageSwitch--active');
        landingPageSection?.classList.remove('landingpageSection--active');
      } else {
        openLandingpageMenu();
        landingpageSwitchMobile?.classList.add('landingPageSwitch--active');
        landingPageSection?.classList.add('landingpageSection--active');
      }
    });
  }

  if (landingpageSwitchDesktop instanceof HTMLElement) {
    landingpageSwitchDesktop.addEventListener('click', () => {
      if (landingpageSwitchDesktop.classList.contains('landingPageSwitch--active')) {
        landingpageSwitchDesktop?.classList.remove('landingPageSwitch--active');
        landingPageSection?.classList.remove('landingpageSection--active');
        landingpageSwitchDesktop?.setAttribute('aria-expanded', 'false');
        closePageOverlay(0);
      } else {
        landingpageSwitchDesktop?.classList.add('landingPageSwitch--active');
        landingPageSection?.classList.add('landingpageSection--active');
        landingpageSwitchDesktop?.setAttribute('aria-expanded', 'true');
        showPageOverlay();
      }
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      landingpageSwitchDesktop?.classList.remove('landingPageSwitch--active');
      landingPageSection?.classList.remove('landingpageSection--active');
      document.querySelector('.js-mobileNavToggle')?.classList.remove('header__mobileNav--active');
      closePageOverlay(0);
      closeLandingpageMenu();
    }
  });
}

export function closeLandingpageMenu() {
  const buttonDesktop = document.querySelector('.js-landingpageSwitchHeader');
  const buttonMobile = document.querySelector('.js-landingpageSwitch');
  const landingPageSection = document.querySelector('.js-landingPageSection');

  if (buttonDesktop instanceof HTMLElement) {
    buttonDesktop?.setAttribute('aria-expanded', 'false');
  }
  if (buttonMobile instanceof HTMLElement) {
    buttonMobile?.classList.remove('landingPageSwitch--active');
    buttonMobile?.setAttribute('aria-expanded', 'false');
  }
  landingPageSection?.classList.remove('landingpageSection--active');
  closePageOverlay(0);
}

export function openLandingpageMenu() {
  const buttonDesktop = document.querySelector('.js-landingpageSwitchHeader');
  const buttonMobile = document.querySelector('.js-landingpageSwitch');
  const landingPageSection = document.querySelector('.js-landingPageSection');

  if (buttonDesktop instanceof HTMLElement) {
    buttonDesktop?.setAttribute('aria-expanded', 'true');
  }
  if (buttonMobile instanceof HTMLElement) {
    buttonMobile?.classList.add('landingPageSwitch--active');
    buttonMobile?.setAttribute('aria-expanded', 'true');
  }
  landingPageSection?.classList.add('landingpageSection--active');
  showPageOverlay();
}
